
import React from 'react';
import LegalHeader from '@/components/LegalHeader';
import Footer from '@/components/Footer';
import TableOfContents from '@/components/privacy/TableOfContents';
import Introduction from '@/components/privacy/Introduction';
import GeneralSection from '@/components/privacy/GeneralSection';
import WebsiteSection from '@/components/privacy/WebsiteSection';
import EmailSection from '@/components/privacy/EmailSection';
import ContractualSection from '@/components/privacy/ContractualSection';
import BusinessPartnerSection from '@/components/privacy/BusinessPartnerSection';
import MobileNavBar from '@/components/mobile/MobileNavBar';
import { useEffect, useState } from 'react';
import { supabase } from '@/integrations/supabase/client';

const Privacy = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const { data: { session } } = await supabase.auth.getSession();
        setIsAuthenticated(!!session);
        
        if (session?.user?.id) {
          const { data: userRole } = await supabase
            .from('user_roles')
            .select('role')
            .eq('user_id', session.user.id)
            .single();
          
          setIsAdmin(userRole?.role === 'admin');
        }
      } catch (error) {
        console.error('Error checking auth:', error);
      } finally {
        setIsLoading(false);
      }
    };

    checkAuth();
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleLogout = async () => {
    try {
      await supabase.auth.signOut();
    } catch (error) {
      console.error('Error logging out:', error);
    }
  };

  return (
    <div className="min-h-screen bg-white flex flex-col">
      <LegalHeader />
      <main className="flex-grow container mx-auto px-4 py-12 max-w-4xl pb-20 md:pb-12">
        <h1 className="text-3xl font-bold text-gray-900 mb-6">Privacy Policy</h1>
        <p className="text-gray-600 mb-8">Last updated: April 2025</p>
        <div className="prose prose-gray max-w-none space-y-8 text-gray-600">
        <TableOfContents />
          <Introduction />
          <GeneralSection />
          <WebsiteSection />
          <EmailSection />
          <ContractualSection />
          <BusinessPartnerSection />
        </div>
      </main>
      <Footer />
      <MobileNavBar
        isAuthenticated={isAuthenticated}
        isAdmin={isAdmin}
        isLoading={isLoading}
        isMenuOpen={isMenuOpen}
        toggleMenu={toggleMenu}
        handleLogout={handleLogout}
      />
    </div>
  );
};

export default Privacy;
